<patron-toolbar>
  <div class="container">
    <div class="flex justify-content-end">
      <patron-button (click)="save()" iconName="bi-check2" [loading]="loading">
        Salvar
      </patron-button>
    </div>
  </div>
</patron-toolbar>

<div class="container">
  <div class="card mt-3">
    <div class="card-body">
      <patron-tabview [tabs]="[{ header: 'Dados do perfil', template: tab }]">
        <ng-template #tab>
          <div class="row d-flex justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8">
              <patron-form [formGroup]="formGroup">
                <patron-form-field
                  [formGroup]="formGroup"
                  formControlName="name"
                  label="Nome"></patron-form-field>

                <patron-select
                  [formGroup]="formGroup"
                  formControlName="type"
                  label="Tipo Acesso"
                  [items]="[
                    { label: 'Usuário', value: 'U' },
                    { label: 'Cliente', value: 'C' },
                    { label: 'Fornecedor', value: 'S' },
                  ]"
                  bindLabel="label"
                  bindValue="value"
                  (onChange)="updateSelectAllValues(true)">
                </patron-select>

                <div class="flex flex-column md:flex-row">
                  <div class="me-3">
                    <patron-switch
                      [formGroup]="formGroup"
                      formControlName="observation"
                      [trueValue]="true"
                      [falseValue]="false"
                      label="Observações obrigatórias">
                    </patron-switch>
                  </div>
                  <div>
                    <patron-switch
                      [formGroup]="formGroup"
                      formControlName="attachments"
                      [trueValue]="true"
                      [falseValue]="false"
                      label="Anexos obrigatórios">
                    </patron-switch>
                  </div>
                </div>
              </patron-form>
            </div>
          </div>
        </ng-template>
      </patron-tabview>
      <patron-tabview
        [tabs]="[
          { header: 'Módulos', template: modulesTab },
          { header: 'Usuários', template: usersTab },
          { header: 'Pipelines', template: pipelinesTab },
        ]">
        <ng-template #modulesTab>
          <div class="card mt-4">
            <div class="card-body p-0">
              <table class="table m-0">
                <thead>
                  <tr>
                    <th class="surface-200">Módulo</th>
                    <th style="width: 110px" class="text-center surface-200">Listar</th>
                    <th style="width: 110px" class="text-center surface-200">Criar/Editar</th>
                    <th style="width: 110px" class="text-center surface-200">Executar</th>
                    <th style="width: 110px" class="text-center surface-200">Deletar</th>
                  </tr>
                </thead>
                <thead>
                  <tr>
                    <th class="surface-200">
                      <input
                        type="text"
                        class="input-sm form-control"
                        placeholder="Filtrar módulos"
                        [(ngModel)]="filterModulesText" />
                    </th>
                    <th style="width: 110px" class="text-center surface-200">
                      @if (isSelectedAll.can_read != undefined) {
                        <span>
                          <patron-switch
                            [(ngModel)]="isSelectedAll.can_read"
                            (ngModelChange)="selectAllToggle($event, 'can_read')"
                            [ngModelOptions]="{ standalone: true }">
                          </patron-switch>
                        </span>
                      }
                    </th>
                    <th style="width: 110px" class="text-center surface-200">
                      @if (isSelectedAll.can_write != undefined) {
                        <span>
                          <patron-switch
                            [(ngModel)]="isSelectedAll.can_write"
                            (ngModelChange)="selectAllToggle($event, 'can_write')"
                            [ngModelOptions]="{ standalone: true }">
                          </patron-switch>
                        </span>
                      }
                    </th>
                    <th style="width: 110px" class="text-center surface-200">
                      @if (isSelectedAll.can_execute != undefined) {
                        <span>
                          <patron-switch
                            [(ngModel)]="isSelectedAll.can_execute"
                            (ngModelChange)="selectAllToggle($event, 'can_execute')"
                            [ngModelOptions]="{ standalone: true }">
                          </patron-switch>
                        </span>
                      }
                    </th>
                    <th style="width: 110px" class="text-center surface-200">
                      @if (isSelectedAll.can_destroy != undefined) {
                        <span>
                          <patron-switch
                            [(ngModel)]="isSelectedAll.can_destroy"
                            (ngModelChange)="selectAllToggle($event, 'can_destroy')"
                            [ngModelOptions]="{ standalone: true }">
                          </patron-switch>
                        </span>
                      }
                    </th>
                  </tr>
                </thead>
                @for (f of formModules; track f) {
                  <tbody class="mb-4">
                    @if ((f.modules | filterModules: filterModulesText).length) {
                      <tr>
                        <td class="surface-100 pt-5">
                          <h6 class="mb-0">{{ f.group }}</h6>
                        </td>
                        <td class="surface-100 text-center pt-5">
                          @if (isSelectedGroup?.[f.group]?.['can_read'] != undefined) {
                            <span>
                              <patron-switch
                                [(ngModel)]="isSelectedGroup[f.group]['can_read']"
                                (ngModelChange)="selectAllToggle($event, 'can_read', f.group)"
                                [ngModelOptions]="{ standalone: true }">
                              </patron-switch>
                            </span>
                          }
                        </td>
                        <td class="surface-100 text-center pt-5">
                          @if (isSelectedGroup?.[f.group]?.['can_write'] != undefined) {
                            <span>
                              <patron-switch
                                [(ngModel)]="isSelectedGroup[f.group]['can_write']"
                                (ngModelChange)="selectAllToggle($event, 'can_write', f.group)"
                                [ngModelOptions]="{ standalone: true }">
                              </patron-switch>
                            </span>
                          }
                        </td>
                        <td class="surface-100 text-center pt-5">
                          @if (isSelectedGroup?.[f.group]?.['can_execute'] != undefined) {
                            <span>
                              <patron-switch
                                [(ngModel)]="isSelectedGroup[f.group]['can_execute']"
                                (ngModelChange)="selectAllToggle($event, 'can_execute', f.group)"
                                [ngModelOptions]="{ standalone: true }">
                              </patron-switch>
                            </span>
                          }
                        </td>
                        <td class="surface-100 text-center pt-5">
                          @if (isSelectedGroup?.[f.group]?.['can_destroy'] != undefined) {
                            <span>
                              <patron-switch
                                [(ngModel)]="isSelectedGroup[f.group]['can_destroy']"
                                (ngModelChange)="selectAllToggle($event, 'can_destroy', f.group)"
                                [ngModelOptions]="{ standalone: true }">
                              </patron-switch>
                            </span>
                          }
                        </td>
                      </tr>
                    }
                    @for (module of f.modules | filterModules: filterModulesText; track module) {
                      <tr>
                        <td>
                          <div>
                            <span
                              [innerHTML]="
                                module.label | highlight: filterModulesText : false : true
                              "></span>
                          </div>
                          @for (system of module.systems; track system) {
                            <patron-badge size="sm" color="primary" class="me-1"
                              >{{ system.name }}
                            </patron-badge>
                          }
                        </td>
                        <td class="text-center">
                          @if (module.can_read?.includes(profileAccessType)) {
                            <patron-switch
                              [(ngModel)]="getModule(module).can_read"
                              [ngModelOptions]="{ standalone: true }"
                              [trueValue]="1"
                              [falseValue]="0"
                              (ngModelChange)="updateSelectAllValues()">
                            </patron-switch>
                          }
                        </td>
                        <td class="text-center">
                          @if (module.can_write?.includes(profileAccessType)) {
                            <patron-switch
                              [(ngModel)]="getModule(module).can_write"
                              [ngModelOptions]="{ standalone: true }"
                              [trueValue]="1"
                              [falseValue]="0"
                              (ngModelChange)="updateSelectAllValues()">
                            </patron-switch>
                          }
                        </td>
                        <td class="text-center">
                          @if (module.can_execute?.includes(profileAccessType)) {
                            <patron-switch
                              [(ngModel)]="getModule(module).can_execute"
                              [ngModelOptions]="{ standalone: true }"
                              [trueValue]="1"
                              [falseValue]="0"
                              (ngModelChange)="updateSelectAllValues()">
                            </patron-switch>
                          }
                        </td>
                        <td class="text-center">
                          @if (module.can_destroy?.includes(profileAccessType)) {
                            <patron-switch
                              [(ngModel)]="getModule(module).can_destroy"
                              [ngModelOptions]="{ standalone: true }"
                              [trueValue]="1"
                              [falseValue]="0"
                              (ngModelChange)="updateSelectAllValues()">
                            </patron-switch>
                          }
                        </td>
                      </tr>
                    }
                  </tbody>
                }
              </table>
            </div>
          </div>
        </ng-template>
        <ng-template #usersTab>
          @if (loadingBwUsers) {
            <div>Carregando usuários...</div>
          }
          @if (bwUsers) {
            <div>
              <div class="d-flex align-items-center justify-content-between mt-4 gap-3">
                <small class="text-muted">
                  {{ bwUsers.length }} usuário(s) com este perfil. O vínculo é salvo ao confirmar.
                </small>
                <patron-search-modal
                  path="bw-users"
                  modal-title="Adicionar usuários ao perfil"
                  [findOptions]="bwUsersFindOptions"
                  (onConfirm)="saveBwUsers($event)"
                  [checkedItems]="bwUsersIds">
                  <patron-icon name="bi-people" class="me-2"></patron-icon>
                  Adicionar/remover usuários
                </patron-search-modal>
              </div>
              <div class="card mt-3">
                <div class="card-body p-0">
                  <table class="table m-0">
                    <thead>
                      <tr>
                        <th class="surface-200">Nome</th>
                        <th class="surface-200">E-mail</th>
                      </tr>
                    </thead>
                    <thead>
                      <tr>
                        <th class="surface-200" colspan="2">
                          <input
                            type="text"
                            class="input-sm form-control"
                            placeholder="Filtrar usuários"
                            [(ngModel)]="filterUsersText"
                            [ngModelOptions]="{ standalone: true }" />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (user of filteredBwUsers; track user.id) {
                        <tr>
                          <td>{{ user.name }}</td>
                          <td>{{ user.email }}</td>
                        </tr>
                      }
                      @if (!filteredBwUsers.length) {
                        <tr>
                          <td colspan="2" class="text-center text-muted">
                            {{
                              bwUsers.length
                                ? 'Nenhum usuário encontrado.'
                                : 'Nenhum usuário vinculado a este perfil.'
                            }}
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          }
        </ng-template>
        <ng-template #pipelinesTab>
          <app-pipeline-access owner="profile" [ownerId]="profile.id" [showSaveButton]="false" />
        </ng-template>
      </patron-tabview>
    </div>
  </div>
</div>

@if (loading) {
  <patron-overlay></patron-overlay>
}
